import addDays from './addDays';
import getDay from './getDay';

export function getNearestDay(date, targetDay) {
  const daysInWeek = 7;
  const currentDay = getDay(date);

  const daysUntilTarget = (targetDay - currentDay + daysInWeek) % daysInWeek;
  const daysSinceTarget = (currentDay - targetDay + daysInWeek) % daysInWeek;

  const nearestDayPast = addDays(date, -daysSinceTarget);
  const nearestDayFuture = addDays(date, daysUntilTarget);

  return daysSinceTarget <= daysUntilTarget ? nearestDayPast : nearestDayFuture;
}
